import { __ } from '@wordpress/i18n';
import PropTypes from 'prop-types';
import React from 'react';

// Components.
import Chart from '@/components/chart';
import Filters from '@/components/filters';
import Table from '@/components/table';
import Tabs from '@/components/tabs';

// Hooks.
import useData from '@/hooks/use-data';
import useFilters from '@/hooks/use-filters';

// Services.
import filterData from '@/services/data/filter-data';
import filterValues from '@/services/data/filter-values';
import getData from '@/services/data/get-data';

/**
 * The root-level App component, which has access to the query string via
 * React Router.
 * @returns {JSX.Element}
 */
const App = ({ definitions }) => {
  const {
    config,
    disambiguatedFilters,
    isLoading,
    maxYear,
    minYear,
    series,
  } = useData();
  const filters = useFilters();
  const data = getData(config, series, filters, disambiguatedFilters);
  const allTypesData = filterValues(
    config,
    filterData(series.allTypes, null, null, null),
    filters.outputType,
  );

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <Tabs filters={filters} />
      <div className="hst-container">
        <div className="hst-container--right">
          <Filters
            definitions={definitions}
            filters={filters}
            maxYear={maxYear}
            minYear={minYear}
          />
        </div>
        <div className="hst-container--left">
          {isLoading ? (
            <div className="hst-loading" role="alert" aria-busy="true" aria-label={__('Loading...', 'hst')} />
          ) : (
            <>
              <Chart
                data={data}
                disambiguatedFilters={disambiguatedFilters}
                filters={filters}
              />
              <Table
                data={data}
                disambiguatedFilters={disambiguatedFilters}
                filters={filters}
                toplineData={allTypesData}
              />
            </>
          )}
        </div>
      </div>
    </form>
  );
};

App.defaultProps = {
  definitions: '',
};

App.propTypes = {
  definitions: PropTypes.string,
};

export default App;
